export const environment = {
  production: false,
  googleAuthUrl:
    'https://dev.projeto.saudeconectada.cists.com.br/backend/oauth2/authorization/google',
  azureAuthUrl:
    'https://dev.projeto.saudeconectada.cists.com.br/backend/oauth2/authorization/azure',
  apiUrl: 'https://dev.projeto.saudeconectada.cists.com.br/backend/api',
  serverUrl: 'https://dev.projeto.saudeconectada.cists.com.br/backend'
};
